import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchDrawdownsResponse, fetchDrawdowns, fetchDrawdownsForExport } from './drawdowns.thunks';
import { IDrawdownsState } from './interfaces';

const initialState: IDrawdownsState = {
  loading: false,
  list: [],
  totalDocs: 1,
  exportList: [],
  exporting: false
};

const drawdownsSlices = createSlice({
  name: 'drawdowns',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchDrawdowns?.pending.type]: (state) => {
      state.loading = true;
    },
    [fetchDrawdowns?.fulfilled.type]: (state, action: PayloadAction<IFetchDrawdownsResponse>) => {
      state.loading = false;
      state.list = action.payload.docs.map((doc) => {
        const { dealId, credits, closeDate, status, members, dealName, projectName } = doc;
        return {
          dealId,
          credits,
          closeDate,
          status,
          members,
          dealName,
          projectName: projectName ?? 'TBD'
        };
      });
      state.totalDocs = action.payload.totalDocs;
    },
    [fetchDrawdowns?.rejected.type]: (state) => {
      state.loading = false;
    },
    [fetchDrawdownsForExport?.pending.type]: (state) => {
      state.exporting = true;
    },
    [fetchDrawdownsForExport?.fulfilled.type]: (state, action: PayloadAction<IFetchDrawdownsResponse>) => {
      state.exporting = false;
      state.exportList = action.payload.docs ?? [];
    },
    [fetchDrawdownsForExport?.rejected.type]: (state) => {
      state.exporting = false;
    }
  }
});

export const actions = {
  ...drawdownsSlices.actions
};

export const drawdownsReducer = drawdownsSlices.reducer;
